import { AgGridTable } from 'core/components';
import { TableLayoutType } from 'core/enums';
import { AgGridClientTableProvider } from 'core/states';
import { ISelectionActionProps } from 'core/types';
import { useGetJobCustomers } from 'jobs/hooks';
import { IJobCustomer } from 'jobs/types';

import { RemoveCustomersButton, UpsertCustomerButton } from './actions';
import { getColumnDefs } from './columns';

interface IProps {
  jobId: number;
  projectId: number;
}

export const CustomerList = ({ jobId, projectId }: IProps) => {
  const { records, isLoading, loadingPercentage, currentPage } = useGetJobCustomers({
    filters: { bomId: jobId },
  });

  const columnDefs = getColumnDefs(jobId, projectId);

  const actionButtons = () => {
    return [<UpsertCustomerButton key="addCustomerButton" jobId={jobId} projectId={projectId} />];
  };

  const selectionActionButtons = ({ selectedRows }: ISelectionActionProps) => {
    return [
      <RemoveCustomersButton
        key="removeCustomersButton"
        jobId={jobId}
        customers={selectedRows as IJobCustomer[]}
      />,
    ];
  };

  return (
    <AgGridClientTableProvider
      tableId="jobCustomerList"
      entityType="Customer"
      columnDefs={columnDefs}
      data={records}
      isDataLoading={isLoading}
      loadingPercentage={loadingPercentage}
      dataCurrentPage={currentPage}
      selectionColumnDef={{ pinned: 'left', lockPinned: true }}
      headerCheckbox
      layoutType={TableLayoutType.JOB_CUSTOMERS}
      hasLayoutActions
    >
      <AgGridTable actionButtons={actionButtons} selectionActionButtons={selectionActionButtons} />
    </AgGridClientTableProvider>
  );
};
